import { MsalProvider } from '@azure/msal-react';
import { initalizeMsalInstance } from '@kf/ic2fx';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.scss';
import './polyfills/node-globals';
import './index.css';
import { msalConfig } from "./auth/msalConfig";
import { PublicClientApplication } from '@azure/msal-browser';


const msalInstance = new PublicClientApplication(msalConfig);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
 

root.render(
  <MsalProvider instance={msalInstance}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </MsalProvider>,
);
